import { DASHBOARD, LOGIN } from 'component/app/view'

import {
  ALLOW_COOKIE,
  SET_VIEW,
  SAVE_FILTER,
  FETCH_FILTER,
  FETCH_FILTER_SUCCESS,
  FETCH_COOKIE_OPT_IN_SUCCESS
} from 'react-redux/actions/app'

import {
  START_DRAG,
  STOP_DRAG,
} from 'react-redux/actions/drag-and-drop'

import {
  LOGIN_SUCCESS,
  LOGOUT_SUCCESS,
  LOGOUT_FAIL,
  FETCH_SUCCESS,
} from 'react-redux/actions/user'


const initialState = {
  cookieAllowed: false,
  view: DASHBOARD,
  filter: {
    expression: "",
    fetching: false,
    initialized: false
  }
}

const app = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_COOKIE_OPT_IN_SUCCESS: {
      return Object.assign({}, state, { cookieAllowed: action.payload })
    }
    case SET_VIEW: {
      return Object.assign({}, state, { view: action.view })
    }
    case SAVE_FILTER: {
      const filter = Object.assign(
        {},
        state.filter,
        { expression: action.payload}
      )
      return Object.assign({}, state, { filter } )
    }
    case FETCH_FILTER: {
      const filter = Object.assign(
        {},
        state.filter,
        { fetching: true }
      )
      return Object.assign({}, state, { filter })
    }
    case FETCH_FILTER_SUCCESS: {
      const filter = Object.assign(
        {},
        state.filter,
        {
          expression: action.payload || "",
          fetching: false,
          initialized: true
        }
      )
      return Object.assign(
        {},
        state,
        {
          filter
        }
      )
    }
    default:
      return state
  }
}

export default app



// WEBPACK FOOTER //
// ./src/app/react-redux/reducers/app.js